import { Enums } from '../../db_types'

export type StatementPaymentEligibilityInput = {
  status?: Enums<'statement_status'> | null
  has_pending_payouts?: boolean | null
  hasStatementApprovalFlow: boolean
  hasPayoutValidationFlow: boolean
}

export type StatementPaymentIneligibilityReason =
  | 'approval_required'
  | 'pending_payouts'

export const requiresApprovedStatementForPayment = ({
  hasStatementApprovalFlow,
  hasPayoutValidationFlow
}: Pick<
  StatementPaymentEligibilityInput,
  'hasStatementApprovalFlow' | 'hasPayoutValidationFlow'
>) => hasStatementApprovalFlow || hasPayoutValidationFlow

export const getStatementPaymentIneligibilityReason = ({
  status,
  has_pending_payouts,
  ...flowConfig
}: StatementPaymentEligibilityInput):
  | StatementPaymentIneligibilityReason
  | undefined => {
  if (
    requiresApprovedStatementForPayment(flowConfig) &&
    status !== 'approved'
  ) {
    return 'approval_required'
  }

  if (has_pending_payouts) {
    return 'pending_payouts'
  }

  return undefined
}

export const isStatementEligibleForPayment = (
  input: StatementPaymentEligibilityInput
) =>
  input.status !== 'paid' &&
  getStatementPaymentIneligibilityReason(input) === undefined
